<template>
  <modal id="form-indicador-pessoal" :titulo="titulo" :loading="!form || loading">

    <template #actions>

      <li class="list-inline-item" v-if="form && form.indicadorPessoalId">
        <a @click.prevent="consultarVersoes()" title="Consultar Versões" href>
          CONSULTAR VERSÕES
        </a>
      </li>

    </template>

    <form @submit.prevent="" v-if="form" autocomplete="off">
      <card>

        <card-content class="row gutters-xs">

          <v-input v-model="form.versao" type="text" :disabled="true" label="Versão" class="col-1"/>

          <v-input v-model="form.nome" :error="validation.nome" @blur="validarNome()"
                   type="text" :required="true" label="Nome" class="col dv-focus-nome" :class="{'campo-pendente': isPendente('nome')}"/>
          <div class="w-100"></div>

          <v-input v-if="form.tipoPessoa === 'FISICA'" v-model="form.nomeSocial" :error="validation.nomeSocial"
                   type="text" :required="true" label="Nome Social" class="col"/>

          <div class="w-100"></div>

          <v-input v-model="form.tipoPessoa"
                   :options="options.tiposPessoa" type="select"
                   :required="true" label="Tipo de pessoa" class="col-4"/>

          <v-input v-model="form.documentoDesconhecido" :label="labelDocumentoDesconhecido" type="radio" class="col-3" :class="{'campo-pendente': isPendente('documentoDesconhecido')}"/>

          <template v-if="!form.documentoDesconhecido">
            <template v-if="form.tipoPessoa == 'JURIDICA'">
              <v-input :id="'doc'+form.tipoPessoa" :error="validation.documento" :required="true" v-model="form.documento"
                       @blur="validarDocumento()" type="cnpj" label="CNPJ"  class="col-3" :disabled="disabledDocumento" :class="{'campo-pendente': isPendente('documento')}"/>
            </template>

            <template v-else>
              <v-input :id="'doc'+form.tipoPessoa" :error="validation.documento" :required="true" v-model="form.documento"
                       @blur="validarDocumento()" type="cpf" label="CPF" class="col-5" :disabled="disabledDocumento" :class="{'campo-pendente': isPendente('documento')}" />
            </template>
          </template>
          <template v-else>
            <v-input v-model="form.motivoDocumentoDesconhecido"
                     :options="options.motivoDocumentoDesconhecido"
                     :error="validation.motivoDocumentoDesconhecido"
                     type="v-select" :label="labelMotivoDocumentoDesconhecido" class="col"/>
          </template>

          <template v-if="form.tipoPessoa == 'FISICA'">

            <div class="w-100"></div>
            <v-input class="col" v-model="form.rg" type="text" label="RG" :class="{'campo-pendente': isPendente('rg')}"/>
            <v-input class="col" v-model="form.orgaoEmissor" type="text" label="Órgão Emissor" :inputProps="{ 'maxlength': 150}" :class="{'campo-pendente': isPendente('orgaoEmissor')}"/>
            <v-input class="col-3" v-model="form.ufOrgaoEmissor" :options="options.estados" type="select" label="UF Órgão Emissor"/>
            <v-input class="col" v-model="form.dataEmissaoRg" type="date" label="Data Emissão" :class="{'campo-pendente': isPendente('dataEmissaoRg')}"/>
            <div class="w-100"></div>
            <v-input class="col" v-model="form.oab" type="text" label="OAB" :class="{'campo-pendente': isPendente('oab')}"/>
            <v-input class="col-2" v-model="form.ufOab" :options="options.estados" type="select" label="UF OAB"/>
            <v-input class="col" v-model="form.cip" type="text" label="Identidade profissional" :class="{'campo-pendente': isPendente('cip')}"/>
            <v-input class="col" v-model="form.passaporte" type="text" label="Passaporte" :class="{'campo-pendente': isPendente('passaporte')}"/>
            <div class="w-100"></div>
            <v-input class="col" v-model="form.outrosDocumentos" type="text" label="Outros Documentos" :class="{'campo-pendente': isPendente('outrosDocumentos')}"/>
            <v-input class="col" v-model="form.cnh" type="text" label="CNH" :class="{'campo-pendente': isPendente('cnh')}"/>
            <div class="w-100"></div>

            <template v-if="form.nacionalidade && form.nacionalidade !== 'BRASIL'">
              <v-input class="col-5" v-model="form.rnm" type="text" label="RNM (Registro Nacional Migratório)"/>
              <v-input class="col-3" v-model="form.dataRnm" type="date" label="Validade RNM"/>
              <v-input class="col-4" v-model="form.emissorRnm" type="text" label="Órgão Emissor RNM"/>
              <div class="w-100"></div>
              <v-input v-model="form.possuiFilhosBrasileiros"
                       type="select" class="col-4" label="Possui filhos brasileiros?"
                       :options="[
                         {id: 'SIM', nome: 'Sim'},
                         {id: 'NAO', nome: 'Não'},
                         {id: 'NAO_INFORMADO', nome: 'Não Informado'}
                       ]" />
              <div class="w-100"></div>
            </template>

            <v-input v-model="form.falecido" label="Pessoa falecida?" type="radio" class="col" />
            <template v-if="form.falecido">
              <v-input class="col" v-model="form.dataObito" type="date" label="Data do Óbito"/>
              <v-input class="col" v-model="form.certidaoObito" type="text" label="Certidão de Óbito"  :inputProps="{ 'maxlength': 500}"/>
            </template>
            <v-input v-model="form.menor" label="Menor de idade?" type="radio" class="col" :class="{'campo-pendente': isPendente('menor')}" />
            <v-input v-model="form.incapaz" label="Incapaz?" type="radio" class="col" :class="{'campo-pendente': isPendente('incapaz')}" />
            <div class="w-100"></div>
            <v-input v-model="form.expostaPoliticamente" label="Pessoa exposta politicamente?" type="radio" class="col" />
            <v-input v-model="form.servidorPublico" label="Servidor Público?" type="radio" class="col" />
            <div class="w-100"></div>
            <v-input v-model="form.deficienteVisual" label="Deficiente Visual ou Visão Subnormal?" type="radio" class="col" :class="{'campo-pendente': isPendente('deficienteVisual')}" />
            <v-input v-model="form.semialfabetizado" label="Semialfabetizado?" type="radio" class="col" :class="{'campo-pendente': isPendente('semialfabetizado')}" />

            <div class="w-100"></div>

          </template>

          <template  v-if="form.tipoPessoa == 'JURIDICA'">

            <div class="w-100"></div>

            <v-input v-model="form.denominacao" type="text" label="Nome Fantasia (Denominação)" class="col" />

            <v-input class="col-3" :error="validation.sexo" v-model="form.sexo" :options="options.sexos" type="select"
                     label="Gênero no texto"/>
          </template>

          <div class="w-100"></div>

          <template v-if="form.tipoPessoa == 'JURIDICA'">
            <v-input v-model="form.substituicaoTributaria" label="Optante de Substituição Tributária?" type="radio" class="col"/>
            <v-input v-model="form.indicadorUniao" label="Indicador da União?" type="radio" class="col"/>
          </template>
          <v-input v-model="form.pessoaObrigada" label="Pessoa Obrigada?" type="radio" class="col" />
          <v-input v-model="form.fornecedor" label="Permitir uso como fornecedor?" type="radio" class="col" :disabled="fornecedor"/>
          <v-input v-model="form.serventiaExtrajudicial" label="Cadastro de Serventia Extrajudicial?" type="radio" class="col" />
          <div class="w-100"></div>

          <v-input v-model="form.sequencial" label="Sequencial" type="text" class="col"/>

        </card-content>

      </card>

      <card titulo="Dados básicos" v-if="form.tipoPessoa == 'FISICA'">
        <card-content class="row gutters-xs">

          <v-input class="col" :error="validation.sexo" v-model="form.sexo" :options="options.sexos" type="select"
                   label="Sexo"/>

          <v-input class="col" v-model="form.nascimento" type="date" label="Data de nascimento"/>

          <v-input v-if="options.nacionalidades.length > 0" class="col-3" v-model="form.nacionalidade"
                   :options="options.nacionalidades" type="v-select" label="Nacionalidade" :class="{'campo-pendente': isPendente('nacionalidade')}"/>

          <v-input class="col-3" label="Profissão" v-model="form.profissao"
                   :error="validation.profissao" type="text" :class="{'campo-pendente': isPendente('profissao')}" />

          <div class="w-100"></div>

          <v-input class="col" v-model="form.nomePai" type="text" label="Nome do pai" :class="{'campo-pendente': isPendente('nomePai')}"/>
          <v-input class="col" v-model="form.nomeMae" type="text" label="Nome da mãe" :class="{'campo-pendente': isPendente('nomeMae')}"/>

          <div class="w-100"></div>

          <template v-if="isBrasileiroNacionalidade">
            <v-input class="col-3" v-model="form.naturalidadeEstado" :options="options.estados" type="select" label="Naturalidade - Estado"/>
            <v-input class="col" v-model="form.naturalidadeCidade" type="text" label="Naturalidade - Cidade"/>
          </template>
          <template v-else>
            <v-input class="col" v-model="form.naturalidadeCidade" type="text" label="Naturalidade - Cidade"/>
          </template>

          <div class="w-100"></div>

          <v-input class="col-3" v-model="form.estadoCivil" :options="options.estadosCivil" type="select"
                   label="Estado civil" :class="{'campo-pendente': isPendente('estadoCivil')}"/>

          <v-input v-if="mostrarTipoSeparacao" class="col-3" v-model="form.tipoSeparacao" :options="options.tipoSeparacao"
                   type="select" :error="validation.tipoSeparacao" :required="$root.isEstadoRJ && form.estadoCivil === 'SEPARADO'" @blur="validarTipoSeparacao()"
                   label="Tipo de Separação"/>

          <v-input class="col-auto" v-model="form.possuiUniaoEstavel" v-if="form.estadoCivil != 'CASADO'" :options="options.uniaoEstavel"
                   type="select"  label="União estável?"/>

        </card-content>
      </card>

      <card :titulo="`${form.estadoCivil === 'CASADO' ? 'Dados do casamento' : 'Dados da união estável'}`"
           v-if="form.tipoPessoa === 'FISICA' && (form.estadoCivil === 'CASADO' || form.possuiUniaoEstavel === 'SIM')">

        <template #acoes v-if="form.conjuge && form.conjuge.id">
          <v-button :button="false" :popover="true" :run="importar" class="btn btn-sm btn-outline-primary mx-1 pointer">
            Importar dados cônjuge
          </v-button>
          <v-button v-if="pessoa.id && !$root.isVhlUser" :button="false" :popover="true" :run="exportar" class="btn btn-sm btn-outline-primary mx-1 pointer"
                    position="dropleft">
            Exportar dados cônjuge
          </v-button>
        </template>

        <card-content class="row gutters-xs">

          <!-- ENCONTRAR CONJUGE -->
          <template v-if="!form.conjuge || !form.conjuge.id">

            <v-input class="col" :label="consorte">
              <buscar-pessoa @add="selecionarConjuge($event)" :novo="true" />
            </v-input>

          </template>

          <template v-else>

            <v-input class="col form-group" :label="consorte">
              <input type="text" readonly v-model="consorteDescricao" class="form-control form-control-xs" />
            </v-input>

            <div class="col-auto">
              <button class="btn btn-outline-secondary btn-xs" style="margin-top: 22px" @click="selecionarConjuge(null)" type="button" title="Remover">
                <i class="fal fa-times"></i>
              </button>
            </div>

            <div class="col-auto">
              <button class="btn btn-outline-secondary btn-xs" style="margin-top: 22px" @click="editarConjuge(form.conjuge)" type="button">
                <i class="fal fa-edit"></i>
              </button>
            </div>

          </template>

          <div class="w-100"></div>

              <v-input v-model="form.casamentoAposLei6515" label="Após lei 6515?"
                       type="radio" class="col-auto" v-if="form.estadoCivil === 'CASADO'"/>
          <template v-if="form.estadoCivil === 'CASADO' || form.possuiUniaoEstavel === 'SIM'">
            <v-input class="col-3" v-model="form.dataCasamento" type="date"
                     :label="form.estadoCivil === 'CASADO' ? 'Data do casamento' : 'Data da união'"/>

            <v-input class="col" v-model="form.regimeCasamento" :options="regimes" type="select" label="Regime"/>
          </template>

          <div class="w-100"></div>

          <v-input class="col" v-model="form.detalhesRegime" type="editor" label="Detalhes do regime"/>

          <div class="w-100"></div>

          <template v-if="form.estadoCivil === 'CASADO'">

            <v-input v-model="form.adicionarRegistroPactoAntenupcial" label="Adicionar dados de registro do pacto antenupcial?"
                     type="radio" class="col-auto"/>

            <div class="w-100"></div>

            <v-input v-model="form.numeroRegistroPactoAntenupcial" label="Número do registro"
                     v-if="form.adicionarRegistroPactoAntenupcial"
                     type="text" class="col-6"/>

            <v-input v-model="form.registroImoveisPactoAntenupcial" label="Registro de Imóveis"
                     v-if="form.adicionarRegistroPactoAntenupcial"
                     type="text" class="col-6"/>

          </template>

        </card-content>

      </card>

      <card :titulo="`${'Dados do casamento'}`"
            v-if="form.tipoPessoa === 'FISICA' && exibirDadosExConjuge">

        <template #acoes v-if="form.exConjuge && form.exConjuge.id">
          <v-button :button="false" :popover="true" :run="importarEx" class="btn btn-sm btn-outline-primary mx-1 pointer">
            Importar dados ex-cônjuge
          </v-button>
          <v-button v-if="pessoa.id && !$root.isVhlUser" :button="false" :popover="true" :run="exportarExConjuge" class="btn btn-sm btn-outline-primary mx-1 pointer"
                    position="dropleft">
            Exportar dados ex-cônjuge
          </v-button>
        </template>

        <card-content class="row gutters-xs">

          <template v-if="!form.exConjuge || !form.exConjuge.id">

            <v-input class="col" :label="exConsorte">
              <buscar-pessoa @add="selecionarExConjuge($event)" :novo="true" />
            </v-input>

          </template>

          <template v-else>

            <v-input class="col form-group" :label="exConsorte">
              <input type="text" readonly v-model="consorteDescricaoExConjuge" class="form-control form-control-xs" />
            </v-input>

            <div class="col-auto">
              <button class="btn btn-outline-secondary btn-xs" style="margin-top: 22px" @click="selecionarExConjuge(null)" type="button" title="Remover">
                <i class="fal fa-times"></i>
              </button>
            </div>

            <div class="col-auto">
              <button class="btn btn-outline-secondary btn-xs" style="margin-top: 22px" @click="editarExConjuge(form.exConjuge)" type="button">
                <i class="fal fa-edit"></i>
              </button>
            </div>

          </template>

          <div class="w-100"></div>

          <v-input class="col-3" v-model="form.dataSeparacao" type="date"
                   label="Data da Separação" v-if="isSeparacao"/>

          <v-input class="col-3" v-model="form.dataExtincaoConjugal" type="date"
                   label="Data da Extinção Conjugal" v-if="isExtincaoConjugal"/>

          <div class="w-100"></div>

          <v-input class="col" v-model="form.detalhesRegimeSeparacao" type="editor" label="Detalhes do regime separação"/>


          <div class="w-100"></div>

        </card-content>

      </card>

      <card titulo="Dados Bancários" v-if="form.fornecedor">
        <card-content class="row gutters-xs">

          <v-input class="col" v-model="form.banco" type="text" label="Banco"/>
          <v-input class="col" v-model="form.agencia" type="text" label="Agência"/>
          <v-input class="col" v-model="form.conta" type="text" label="Conta"/>

        </card-content>

      </card>

      <card titulo="Dados básicos" v-if="form.tipoPessoa == 'JURIDICA'">
        <card-content class="row gutters-xs">

          <v-input class="col-auto" v-model="form.inscricaoEstadual" type="text" label="Inscrição estadual"/>
          <v-input class="col-auto" v-model="form.inscricaoMunicipal" type="text" label="Inscrição municipal"/>
          <v-input class="col-auto" v-model="form.nire" type="mask" :masks="['###########']" label="NIRE"/>

          <v-input v-model="form.possuiParticipacaoEstrangeira" label="Participação estrangeira?"
                   type="radio" class="col-auto"/>
          <div class="w-100" />
          <v-input class="col-12" type="v-select" :options="options.naturezaJuridica" label="Natureza Jurídica"
                   v-model="form.naturezaJuridica" />

          <v-input v-if="form.naturezaJuridica === 'OUTRAS'" class="col-12" type="text" label="Descrição"
                   v-model="form.naturezaJuridicaOutras" />

          <v-input v-if="exibirNaturezaJuridicaOnrtdpj" class="col-12" type="v-select"
                   :options="options.naturezaJuridicaOnrtdpj" label="Natureza Jurídica ONRTDPJ"
                   v-model="form.naturezaJuridicaOnrtdpj" />

        </card-content>

      </card>

      <card titulo="Contato">
        <card-content class="row gutters-xs">

          <v-input class="col" :error="validation.email" @blur="validarEmail()" v-model="form.email" type="email" label="E-mail" :class="{'campo-pendente': isPendente('email')}"/>
          <v-input class="col-3" v-model="form.telefone" type="telefone" label="Telefone" :class="{'campo-pendente': isPendente('telefone')}"/>
          <v-input class="col-3" v-model="form.celular" type="telefone" label="Celular" :class="{'campo-pendente': isPendente('celular')}"/>
          <v-input class="col-3" v-model="form.comercial" type="telefone" label="Comercial"/>

        </card-content>

      </card>

      <card titulo="Endereço">
        <card-content class="row gutters-xs">

          <v-input-cep :validation="validation.cep" v-model="form.cep" @endereco="atualizarEndereco" />

          <v-input class="col-3" v-model="form.tipoLogradouroItn" type="text" label="Tipo Logradouro"/>
          <v-input class="col" v-model="form.logradouro" type="text" label="Logradouro (rua)" :class="{'campo-pendente': isPendente('logradouro')}"/>
          <v-input class="col-2" v-model="form.numero" type="text" label="Número" :class="{'campo-pendente': isPendente('numero')}"/>
          <div class="w-100"></div>
          <v-input class="col" v-model="form.quadra" type="text" label="Quadra"/>
          <v-input class="col" v-model="form.lote" type="text" label="Lote"/>

          <div class="w-100"></div>

          <v-input class="col" v-model="form.bairro" type="text" label="Bairro (setor)" :class="{'campo-pendente': isPendente('bairro')}"/>
          <v-input class="col" v-model="form.cidade" type="text" label="Cidade" :class="{'campo-pendente': isPendente('cidade')}"/>

          <v-input class="col-3" v-model="form.pais" :options="options.nacionalidades" default="BRASIL" type="select-name" nameOptionSelect="pais" label="País"/>
          <v-input class="col-auto" v-model="form.estado" :options="options.estados" type="select" label="Estado" v-if="form.pais == 'BRASIL'" :class="{'campo-pendente': isPendente('estado')}" />

          <div class="w-100"></div>

          <v-input class="col" v-model="form.complemento" type="text" label="Complemento"/>

        </card-content>
      </card>

      <card titulo="Endereço comercial">
        <card-content class="row gutters-xs">

          <v-input-cep :validation="validation.cepComercial" v-model="form.cepComercial" @endereco="atualizarEndereco($event, 'Comercial')" />

          <v-input class="col-3" v-model="form.tipoLogradouroComercialItn" type="text" label="Tipo Logradouro"/>
          <v-input class="col" v-model="form.logradouroComercial" type="text" label="Logradouro (rua)"/>
          <v-input class="col-2" v-model="form.numeroComercial" type="text" label="Número"/>
          <div class="w-100"></div>
          <v-input class="col" v-model="form.quadraComercial" type="text" label="Quadra"/>
          <v-input class="col" v-model="form.loteComercial" type="text" label="Lote"/>

          <div class="w-100"></div>

          <v-input class="col" v-model="form.bairroComercial" type="text" label="Bairro (setor)"/>
          <v-input class="col" v-model="form.cidadeComercial" type="text" label="Cidade"/>
          <v-input class="col-auto" v-model="form.estadoComercial" :options="options.estados" type="select" label="Estado"/>

          <v-input class="col-3" v-model="form.paisComercial" :options="options.nacionalidades" type="select-name" nameOptionSelect="pais" label="País"/>

          <div class="w-100"></div>

          <v-input class="col" v-model="form.complementoComercial" type="text" label="Complemento"/>

        </card-content>
      </card>

      <card>
        <card-content>
          <v-input type="editor" label="Observações" v-model="form.observacao" />
        </card-content>
      </card>

    </form>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary">Cancelar</button>
      <template v-if="!desativarVersionamento">
        <v-button :run="salvar" :popover="true" :params="[true]" class="btn-outline-info ml-1" v-if="form && form.indicadorPessoalId">Editar Versão Atual</v-button>
        <v-button :run="salvar" class="btn-outline-primary ml-auto">Nova Versão</v-button>
      </template>
      <template v-else>
        <v-button :run="salvar" :popover="true" :params="[true]" class="btn-outline-primary ml-auto">Salvar</v-button>
      </template>
    </template>

  </modal>
</template>

<script>
import EnderecoBusiness from "@/business/EnderecoBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import Utils from "@/commons/Utils";
import FormIndicadorPessoal from "@/components/IndicadorPessoal/Form/FormIndicadorPessoal";
import ModalVersoes from "@/components/IndicadorPessoal/Form/ModalVersoes";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal";

export default {
    name: "FormIndicadorPessoal",
    components: {CardContent, Card, Modal},
    props: {
      versaoId: String,
      configurandoConjuge: Boolean,
      fornecedor : {type : Boolean, default : false},
      camposPendentes: { type: Array, default: () => [] },
      serventiaExtrajudicial: {type: Boolean, default: false},
    },

    modal: {
      escapable: false
    },

    data() {
      return {
        form: null,
        validation: {},
        versoes : [],
        nome: null,
        documento: null,
        sequencial: null,
        tipoPessoa: null,
        versao : this.versaoId,
        loading : true,
        options: {
          tiposPessoa: IndicadorPessoalBusiness.getTiposPessoa(),
          estadosCivil: IndicadorPessoalBusiness.getEstadosCivil(),
          tipoSeparacao: IndicadorPessoalBusiness.getTipoSeparacao(),
          uniaoEstavel: IndicadorPessoalBusiness.getUniaoEstavel(),
          sexos: IndicadorPessoalBusiness.getSexos(),
          regimes: IndicadorPessoalBusiness.getRegimes(),
          nacionalidades: IndicadorPessoalBusiness.getNacionalidades(),
          estados: [{id : '', nome : ''}, ...EnderecoBusiness.getEstados()],
          naturezaJuridica: [],
          naturezaJuridicaOnrtdpj: [],
          // TODO: Ajustar para $root.enums no futuro
          motivoDocumentoDesconhecido: [{id: 'DECISAO_JUDICIAL', nome: 'Sem CPF/CNPJ - Decisão Judicial'}, {id: 'NAO_CONSTA', nome: 'Não consta no documento'}]
        },
        pessoa: {},
        selecionado: this.versaoId,
        camposConjuge: ['casamentoAposLei6515', 'dataCasamento', 'regimeCasamento',
          'detalhesRegime', 'detalhesRegimeSeparacao', 'cep', 'tipoLogradouroItn', 'logradouro', 'numero', 'quadra', 'lote', 'bairro', 'cidade', 'estado', 'pais', 'complemento',
          'adicionarRegistroPactoAntenupcial', 'numeroRegistroPactoAntenupcial', 'registroImoveisPactoAntenupcial'],
        camposExConjuge: ['dataSeparacao', 'dataExtincaoConjugal', 'detalhesRegimeSeparacao',
          'cep', 'tipoLogradouroItn', 'logradouro', 'numero', 'quadra', 'lote', 'bairro', 'cidade', 'estado', 'pais', 'complemento']
      }
    },

    async mounted() {
      this.options.naturezaJuridica = IndicadorPessoalBusiness.getNaturezaJuridica();
      this.options.naturezaJuridicaOnrtdpj = IndicadorPessoalBusiness.getNaturezaJuridicaOnrtdpj();
      try {
        await this.load();
      } catch (e) {}
      FrontBusiness.setFocus(this.$el, 'form-indicador-pessoal form .dv-focus-nome div input');
    },

    watch: {
        'form.documentoDesconhecido': function (n) {
            if(n == true || n == 'true') {
                this.$set(this.form, 'documento', null)
                this.$set(this.validation, 'documento', null);
            };
        },
        'form.nacionalidade': function (n) {
            if(!n || n === 'BRASIL') {
                this.$set(this.form, 'rnm', null);
                this.$set(this.form, 'dataRnm', null);
                this.$set(this.form, 'emissorRnm', null);
                this.$set(this.form, 'possuiFilhosBrasileiros', null);
            }
        }
    },

    computed: {

      mostrarTipoSeparacao() {
        return this.form.estadoCivil === 'SEPARADO'
      },

      ativarSubstituicaoTributaria(){
        return this.$root.config?.notaFiscal?.substituicaoTributaria;
      },

      desativarVersionamento(){
        return this.$root?.config?.geral?.desativarVersionamentoPessoas;
      },

      titulo() {
        let base = this.pessoa?.nome ? `${this.pessoa.nome}${this.pessoa.documento ? ' - ' + this.pessoa.documento : ''}` : 'Detalhes Indicador Pessoal';
        if (this.camposPendentes && this.camposPendentes.length > 0) {
          return `${base} (${this.camposPendentes.length} pendências)`;
        }
        return base;
      },

      regimes() {
        return this.options.regimes.filter(e => this.form.casamentoAposLei6515 || this.form.possuiUniaoEstavel === 'SIM' || e.id != 'PARTICIPACAO_FINAL_AQUESTOS');
      },

      isSeparacao() {
        return ['SEPARADO', 'SEPARADO_JUDICIALMENTE'].includes(this.form.estadoCivil);
      },

      isExtincaoConjugal() {
        return ['DIVORCIADO', 'VIUVO'].includes(this.form.estadoCivil);
      },

      exibirDadosExConjuge() {
        return this.isSeparacao || this.isExtincaoConjugal;
      },

      consorte() {
        if (this.form.possuiUniaoEstavel === 'SIM' && this.form.estadoCivil !== 'CASADO') {
          return 'Convivente';
        }
        if (this.exibirDadosExConjuge) {
          return 'Ex-cônjuge';
        }
        return 'Cônjuge';
      },

      exConsorte() {
        return 'Ex-cônjuge';
      },
      consorteDescricao() {
        return `${this.form.conjuge.nome} (Versão: ${this.form.conjuge?.versao})`;
      },

      consorteDescricaoExConjuge() {
        return `${this.form.exConjuge.nome} (Versão: ${this.form.exConjuge?.versao})`;
      },


      indicadorPessoalId(){
        return this.form?.indicadorPessoalId;
      },

      labelDocumentoDesconhecido(){
        return (this.form.tipoPessoa == 'JURIDICA' ? 'CNPJ' : 'CPF') + ' desconhecido?';
      },

      labelMotivoDocumentoDesconhecido() {
        return `Motivo do ${this.form.tipoPessoa == 'JURIDICA' ? 'CNPJ' : 'CPF'} desconhecido`;
      },

      disabledDocumento() {
         return this.form.documentoDesconhecido == true || this.form.documentoDesconhecido == 'true';
      },

      isBrasileiroNacionalidade() {
        return !this.form.nacionalidade || this.form.nacionalidade === 'BRASIL';
      },

      exibirNaturezaJuridicaOnrtdpj() {
        return this.form?.tipoPessoa === 'JURIDICA' && this.$root.isEstadoSP && this.$root.config?.onrtdpj?.habilitarIntegracao;
      }

    },

    methods: {

      async load() {
        this.$set(this, 'loading', true);
        try {
          let indicador = {
            nacionalidade: 'BRASIL', pais: 'BRASIL', paisComercial: 'BRASIL',
            falecido: false,
            menor: false,
            incapaz: false,
            expostaPoliticamente: false,
            pessoaObrigada: false,
            servidorPublico: false,
            deficienteVisual: false,
            semialfabetizado: false,
            fornecedor: this.fornecedor,
            serventiaExtrajudicial: this.serventiaExtrajudicial,
            tipoPessoa: 'FISICA',
            estadoCivil: 'DESCONHECIDO',
            possuiUniaoEstavel: null,
            nire: null
          };

          if (this.selecionado) {
            indicador = await IndicadorPessoalBusiness.getVersaoById(this.selecionado);
            indicador.deficienteVisual = indicador.deficienteVisual ?? false;
            indicador.semialfabetizado = indicador.semialfabetizado ?? false;
          }

          this.documento = indicador.documento;
          this.sequencial = indicador.sequencial;
          this.tipoPessoa = indicador.tipoPessoa;
          this.pessoa = indicador;
          this.nome = indicador.nome;

          this.$set(this, 'form', {...indicador});
          this.$set(this.form, 'possuiUniaoEstavel', indicador?.possuiUniaoEstavel ? 'SIM' : (indicador.possuiUniaoEstavel === null ? 'DESCONHECIDO' : 'NAO'));
          this.$set(this.form, 'documentoDesconhecido', indicador?.indicadorPessoal?.documentoDesconhecido || false);
        } catch (e) {
          FrontBusiness.showError('Erro ao carregar dados do indicador', e);
        } finally {
          this.$set(this, 'loading', false);
          this.$forceUpdate();
        }
      },

      close() {
        FrontBusiness.closeModal();
      },

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '#form-indicador-pessoal');
      },

      async salvar(editar = false) {

        if (this.form.indicadorPessoalId) {
          if (editar === true) {
            if (!this.$root.getPermission({id: 'PERMITIR_EDITAR_VERSAO_INDICADOR_PESSOAL'})) {
              FrontBusiness.showError('', 'Usuário sem permissão para editar versão atual do indicador pessoal');
              return;
            }
          } else {
            if (!this.$root.getPermission({id: 'PERMITIR_GERAR_VERSAO_INDICADOR_PESSOAL'})) {
              FrontBusiness.showError('', 'Usuário sem permissão para criar nova versão do indicador pessoal');
              return;
            }
          }
        } else {
          if (!this.$root.getPermission({id: 'PERMITIR_CADASTRAR_INDICADOR_PESSOAL'})) {
            FrontBusiness.showError('', 'Usuário sem permissão para cadastrar indicador pessoal');
            return;
          }
        }

        let indicador = null;

        if (!(this.form.tipoPessoa == 'FISICA' && (this.form.estadoCivil == 'CASADO' || this.form.possuiUniaoEstavel === 'SIM'))) {
          this.$set(this.form, 'conjuge', null);
          this.$set(this.form, 'casamentoAposLei6515', null);
          this.$set(this.form, 'dataCasamento', null);
          this.$set(this.form, 'regimeCasamento', null);
          this.$set(this.form, 'detalhesRegime', null);
        }

        if (!(this.form.tipoPessoa === 'FISICA' && this.exibirDadosExConjuge)) {
          this.$set(this.form, 'exConjuge', null);
          this.$set(this.form, 'dataSeparacao', null);
          this.$set(this.form, 'detalhesRegimeSeparacao', null);
        }
        if (!(this.form.tipoPessoa === 'FISICA' && this.isExtincaoConjugal)) {
          this.$set(this.form, 'dataExtincaoConjugal', null);
        }

        if (this.form.tipoPessoa == 'FISICA' && this.form.estadoCivil == 'CASADO') {
          this.$set(this.form, 'possuiUniaoEstavel', 'NAO');
        }

        if (this.form.pais != 'BRASIL') {
          this.$set(this.form, 'estado', null);
        }

        if (this.isBrasileiroNacionalidade) {
          this.$set(this.form, 'rnm', null);
          this.$set(this.form, 'dataRnm', null);
          this.$set(this.form, 'emissorRnm', null);
          this.$set(this.form, 'possuiFilhosBrasileiros', null);
        }

        if (!this.form.adicionarRegistroPactoAntenupcial) {
          this.$set(this.form, 'numeroRegistroPactoAntenupcial', null);
          this.$set(this.form, 'registroImoveisPactoAntenupcial', null);
        }

        if (this.form.naturezaJuridica !== 'OUTRAS') {
          this.$set(this.form, 'naturezaJuridicaOutras', null);
        }

        let dto = Utils.clone(this.form);
        dto.indicadorPessoal = {
          id: this.form.indicadorPessoalId,
          nome: this.form.nome,
          documento: !this.disabledDocumento ? this.form.documento : null,
          tipoPessoa: this.form.tipoPessoa,
          telefone: this.form.telefone,
          celular: this.form.celular,
          comercial: this.form.comercial,
          email: this.form.email,
          documentoDesconhecido: this.disabledDocumento,
          fornecedor: this.form.fornecedor,
          serventiaExtrajudicial: this.form.serventiaExtrajudicial,
          banco: this.form.fornecedor ? this.form.banco : null,
          agencia: this.form.fornecedor ? this.form.agencia : null,
          conta: this.form.fornecedor ? this.form.conta : null
        };
        dto.possuiUniaoEstavel = this.form.possuiUniaoEstavel === 'SIM' ? true : (this.form.possuiUniaoEstavel === 'NAO' ? false : null)

        await IndicadorPessoalBusiness.validarDadosCadastroIndicador(dto).then(async (e) => {
          let result = await this.confirmarSalvarAlteracoes(dto);
          if (!result) return;

          if (this.selecionado) {
            indicador = await IndicadorPessoalBusiness.criarVersao(this.form.indicadorPessoalId, editar, dto).catch(this.showError);
          } else {
            indicador = await IndicadorPessoalBusiness.criarIndicador(dto).catch(this.showError);
          }

          if (indicador) {
            FrontBusiness.closeModal(indicador);
          }
        }).catch(e => {
          FrontBusiness.fullErrorHandler(this, e, '#form-indicador-pessoal');
        });


      },

      async validarDocumento() {
        if (this.form.documento) {
          this.$set(this.validation, 'documento', await IndicadorPessoalBusiness.validarDocumentos(this.form.tipoPessoa, this.form.documento.replace(/[^a-zA-Z0-9]/g, ''), true));
        } else if (!this.form.documento) {
          this.$set(this.validation, 'documento', `Necessário informar um ${this.form.tipoPessoa == 'JURIDICA' ? 'CNPJ' : 'CPF'}`);
        }
      },

      async validarNome() {
        if (this.form.nome) {
          this.$set(this.validation, 'nome', await IndicadorPessoalBusiness.validarNome(this.form.nome, this.form.tipoPessoa));
        } else if (!this.form.nome) {
          this.$set(this.validation, 'nome', `Necessário informar um nome`);
        }
      },

      async validarTipoSeparacao() {
        if (this.$root.isEstadoRJ && this.form.estadoCivil === 'SEPARADO') {
          if (this.form.tipoSeparacao) {
            this.$set(this.validation, 'tipoSeparacao', null);
          } else {
            this.$set(this.validation, 'tipoSeparacao', 'Necessário informar o tipo de separação');
          }
        } else {
          this.$set(this.validation, 'tipoSeparacao', null);
        }
      },

      async validarEmail() {
        if (this.form.email) {
          this.$set(this.validation, 'email', await IndicadorPessoalBusiness.validarEmail(this.form.email));
        } else if (!this.form.email) {
          this.$set(this.validation, 'email', `Necessário informar um e-mail`);
        }
      },

      async selecionarConjuge(conjuge) {
        if (conjuge && conjuge.id) {
          try {
            const versaoCompleta = await IndicadorPessoalBusiness.getVersaoById(conjuge.id);
            this.$set(this.form, 'conjuge', versaoCompleta);
          } catch (error) {
            this.$set(this.form, 'conjuge', conjuge);
          }
        } else {
          this.$set(this.form, 'conjuge', conjuge);
        }
      },

      async selecionarExConjuge(exConjuge) {
        if (exConjuge && exConjuge.id) {
          try {
            const versaoCompleta = await IndicadorPessoalBusiness.getVersaoById(exConjuge.id);
            this.$set(this.form, 'exConjuge', versaoCompleta);
          } catch (error) {
            this.$set(this.form, 'exConjuge', exConjuge);
          }
        } else {
          this.$set(this.form, 'exConjuge', exConjuge);
        }
      },

      async editarConjuge(envolvido) {
        let retorno = await FrontBusiness.openModal(FormIndicadorPessoal, {
          versaoId: envolvido?.id,
          configurandoConjuge: true
        });
        if (retorno) {
          this.selecionarConjuge(retorno);
        }
      },

      async editarExConjuge(envolvido) {
        let retorno = await FrontBusiness.openModal(FormIndicadorPessoal, {
          versaoId: envolvido?.id,
          configurandoConjuge: true
        });
        if (retorno) {
          this.selecionarExConjuge(retorno);
        }
      },

      atualizarEndereco(endereco, comercial = '') {
        if (endereco) {
          this.$set(this.form, 'cep' + comercial, endereco.cep || this.form['cep' + comercial]);
          this.$set(this.form, 'logradouro' + comercial, endereco.logradouro || this.form['logradouro' + comercial]);
          this.$set(this.form, 'bairro' + comercial, endereco.bairro || this.form['bairro' + comercial]);
          this.$set(this.form, 'cidade' + comercial, endereco.cidade || this.form['cidade' + comercial]);
          this.$set(this.form, 'estado' + comercial, endereco.estado || this.form['estado' + comercial]);
          this.getFocusElements('Logradouro (rua)');
        }
      },

      getFocusElements(campo) {
        let editor_elements = (document.getElementById('form-indicador-pessoal'))?.querySelectorAll('input, input.form-check-input, select, textarea, a, .document-editor__editable, .add-editor')
        if (!editor_elements) return;
        if (campo == null) {
          editor_elements[0].focus();
        } else {
          for (let i = 0; i < editor_elements.length; i++) {
            let id_campo = (editor_elements[i].id).split('-')[1] == 'in' ? (editor_elements[i].id).split('-')[0] + '-' + editor_elements[i].value : (editor_elements[i].id).split('-')[0];
            if ((campo).indexOf('ENVOLVIDO') != -1) id_campo = (editor_elements[i].id).replace(/-/g, '');
            if (i + 1 < editor_elements.length && id_campo.indexOf(campo) != -1) {
              editor_elements[i].focus();
              break
            }
          }
        }
      },

      async consultarVersoes() {
        let retorno = await FrontBusiness.openModal(ModalVersoes, {pessoa: this.pessoa});
        if (retorno) {
          this.$set(this, 'selecionado', retorno);
          await this.load()
        }
      },

      async confirmarSalvarAlteracoes(dto) {

        let retorno = await IndicadorPessoalBusiness.validarDadosAlteracaoIndicador(dto);
        if (retorno !== '') {
          return FrontBusiness.showConfirmacao(retorno, 'Deseja continuar?', 'checkbox', 'Tenho certeza que desejo continuar.').then(r => {
            if (r.isConfirmed) {
              return true;
            } else {
              return false
            }
          }).catch(this.showError)
        }
        return true;
      },

      importar() {
        if (!this.form.conjuge) {
          FrontBusiness.showError('', 'Nenhum cônjuge selecionado para importar dados');
          return;
        }
        this.camposConjuge.map(campo => {
          this.$set(this.form, campo, this.form.conjuge[campo]);
        });
        FrontBusiness.showSuccess('', 'Dados importados com sucesso');
      },

      importarEx() {
        if (!this.form.exConjuge) {
          FrontBusiness.showError('', 'Nenhum ex-cônjuge selecionado para importar dados');
          return;
        }
        this.camposExConjuge.map(campo => {
          this.$set(this.form, campo, this.form.exConjuge[campo]);
        });
        FrontBusiness.showSuccess('', 'Dados importados com sucesso');
      },

      async exportar() {
        if (!this.form.conjuge || !this.form.conjuge.id) {
          FrontBusiness.showError('', 'Nenhum cônjuge selecionado para exportar dados');
          return;
        }

        try {
          this.camposConjuge.map(campo => {
            this.$set(this.form.conjuge, campo, this.form[campo]);
          });

          this.$set(this.form.conjuge, 'conjuge', {id: this.form.id});

          let dto = Utils.clone(this.form.conjuge);
          dto.indicadorPessoal = {
            id: dto.indicadorPessoalId,
            nome: dto.nome,
            documento: dto.documento,
            tipoPessoa: dto.tipoPessoa,
            telefone: dto.telefone,
            celular: dto.celular,
            comercial: dto.comercial,
            email: dto.email,
            documentoDesconhecido: dto?.indicadorPessoal?.documentoDesconhecido,
            fornecedor: dto?.indicadorPessoal?.fornecedor,
            substituicaoTributaria: dto?.indicadorPessoal?.substituicaoTributaria,
            banco: dto?.indicadorPessoal?.banco,
            agencia: dto?.indicadorPessoal?.agencia,
            conta: dto?.indicadorPessoal?.conta
          };

          dto.possuiUniaoEstavel = this.form.possuiUniaoEstavel === 'SIM' ? true :
            (this.form.possuiUniaoEstavel === 'NAO' ? false : null);

          let editar = this.$root.config?.geral?.desativarVersionamentoAutomatico || false;
          let conjuge = await IndicadorPessoalBusiness.criarVersao(dto.indicadorPessoalId, editar, dto);

          if (conjuge) {
            this.$set(this.form, 'conjuge', conjuge);
            FrontBusiness.showSuccess('', 'Dados exportados com sucesso');
          }
        } catch (error) {
          this.showError(error);
        }
      },

      async exportarExConjuge() {
        if (!this.form.exConjuge || !this.form.exConjuge.id) {
          FrontBusiness.showError('', 'Nenhum ex-cônjuge selecionado para exportar dados');
          return;
        }

        try {
          this.camposExConjuge.map(campo => {
            this.$set(this.form.exConjuge, campo, this.form[campo]);
          });

          this.$set(this.form.exConjuge, 'exConjuge', {id: this.form.id});

          let dto = Utils.clone(this.form.exConjuge);
          dto.indicadorPessoal = {
            id: dto.indicadorPessoalId,
            nome: dto.nome,
            documento: dto.documento,
            tipoPessoa: dto.tipoPessoa,
            telefone: dto.telefone,
            celular: dto.celular,
            comercial: dto.comercial,
            email: dto.email,
            documentoDesconhecido: dto?.indicadorPessoal?.documentoDesconhecido,
            fornecedor: dto?.indicadorPessoal?.fornecedor,
            substituicaoTributaria: dto?.indicadorPessoal?.substituicaoTributaria,
            banco: dto?.indicadorPessoal?.banco,
            agencia: dto?.indicadorPessoal?.agencia,
            conta: dto?.indicadorPessoal?.conta
          };

          dto.possuiUniaoEstavel = false;

          let editar = this.$root.config?.geral?.desativarVersionamentoAutomatico || false;
          let exConjuge = await IndicadorPessoalBusiness.criarVersao(dto.indicadorPessoalId, editar, dto);

          if (exConjuge) {
            this.$set(this.form, 'exConjuge', exConjuge);
            FrontBusiness.showSuccess('', 'Dados exportados com sucesso');
          }
        } catch (error) {
          this.showError(error);
        }
      },

      isPendente(campo) {
        return this.camposPendentes && this.camposPendentes.includes(campo);
      }
    }
  }
</script>

<style lang=scss>
  #form-indicador-pessoal {
    .card {
      hr {
        margin-top: .25rem;
      }

      .card-body {
        padding-bottom: 0;
      }
    }
  }

  .campo-pendente {
    input, select, textarea {
      border-color: #f0ad4e;
      box-shadow: 0 0 0 0.2rem rgba(240, 173, 78, 0.2);
    }
    .vs__dropdown-toggle {
      border-color: #f0ad4e;
    }
    label {
      color: #f0ad4e;
      font-weight: 600;
    }
  }
</style>
